import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchJobOperatorsOperation({ jobOperatorsOperationParams }) {
  try {
    yield put(Actions.setJobOperatorsOperationLoaderStatus({ jobOperatorOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'joblabour/getsearched',
      params: jobOperatorsOperationParams,
    });
    const jobOperatorsOperationData = data;
    yield put(Actions.setJobOperatorsOperation({ jobOperatorsOperationData }));
    yield put(Actions.setJobOperatorsOperationLoaderStatus({ jobOperatorOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setJobOperatorsOperationLoaderStatus({ jobOperatorOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addUpdateJobOperatorsOperation({ actionName, jobOperatorsOperationObj, jobOperatorsOperationParams }) {
  try {
    yield put(Actions.setJobOperatorsOperationLoaderStatus({ jobOperatorOperationsLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: `joblabour`,
      data: jobOperatorsOperationObj,
    });
    yield put(Actions.fetchJobOperatorsOperation({ jobOperatorsOperationParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.JOB_OPERATOR_CREATED
        : CONSTANT_VARIABLES.JOB_OPERATOR_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setJobOperatorsOperationLoaderStatus({ jobOperatorOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteJobOperatorsOperation({ jobOperatorsId, jobOperatorsOperationParams }) {
  try {
    yield put(Actions.setJobOperatorsOperationLoaderStatus({ jobOperatorOperationsLoader: true }));
    yield call(api.delete, {
      route: `joblabour/${jobOperatorsId}`,
    });
    yield put(Actions.fetchJobOperatorsOperation({ jobOperatorsOperationParams }));
    notification('success', CONSTANT_VARIABLES.JOB_OPERATOR_DELETED, '');
  } catch (err) {
    yield put(Actions.setJobOperatorsOperationLoaderStatus({ jobOperatorOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_JOB_OPERATORS_OPERATION, fetchJobOperatorsOperation),
    takeLatest(ActionTypes.ADD_UPDATE_JOB_OPERATOR_OPERATION, addUpdateJobOperatorsOperation),
    takeLatest(ActionTypes.DELETE_JOB_OPERATOR_OPERATION, deleteJobOperatorsOperation),
  ]);
}
